import React, { useState } from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import Button from "react-bootstrap/Button";
import "../../../../src/main.css";
import SelectAgent from "./SelectAgent";

import { Select } from "antd";
import {
  activeStatus,
  attemptStatus,
  orderOptions,
  slotLead,
} from "modules/utilities/utility";
import Offcanvas from "react-bootstrap/Offcanvas";
import CallType from "modules/dashboards/feedback_form/CallType";
function EngagementFilter({
  selectedAgent,
  setSelectedAgent,
  selectedTempAgent,
  setSelectedTempAgent,
  selectedStatus,
  setSelectedStatus,
  setSelectedGender,
  setOrderFilter,
  agent,
  tempAgents,
  applyFilter,
  clearFilter,
  selectedLeadAgent,
  setSelectedLeadAgent,
  slotType,
  setSlotType,
  activeTab,
  selectMaladAgent,
  setMaladSelectAgent,
  setSelectAttempt,
  selectIvr,
  setIvrAgent,
  selectReceptioninst,
  setSelectReceptioninst
}) {
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  return (
    <>
      <OverlayTrigger
        overlay={
          <Tooltip style={{ position: "fixed" }} id="overlay-trigger-example">
            <span className="fw-bold">Filter by Agent & Download</span>
          </Tooltip>
        }
      >
        <Button
          variant="primary"
          onClick={handleShow}
          className="mt-1 float-end"
        >
          + more
        </Button>
      </OverlayTrigger>
      <Offcanvas
        show={show}
        onHide={handleClose}
        key={6}
        style={{ width: "40vw" }}
        placement={"end"}
      >
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>
            <h1>Traya</h1>
          </Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <div className="d-flex gap-2 flex-column">
            <div className="mb-4">
              <SelectAgent
                name="Select Agent"
                selectedAgent={selectedAgent}
                setSelectedAgent={setSelectedAgent}
                agent={agent}
              />
            </div>
            <div className="mt-5 mb-4">
              <SelectAgent
                name="Select Temp Agent"
                selectedAgent={selectedTempAgent}
                setSelectedAgent={setSelectedTempAgent}
                agent={tempAgents}
              />
            </div>
            <div className="mt-5 mb-4">
              <SelectAgent
                name="Select Offline Agents"
                selectedAgent={selectReceptioninst}
                setSelectedAgent={setSelectReceptioninst}
                agent={agent}
                lead={true}
                level={2}
                clinic={true}
              />
            </div>
            {["slot_booking", "slot_booking_total"].includes(activeTab) && (
              <div className="mt-5 mb-4">
                <SelectAgent
                  name="Select Malad Lead Agent"
                  selectedAgent={selectedLeadAgent}
                  setSelectedAgent={setSelectedLeadAgent}
                  agent={agent}
                  lead={true}
                  level={1}
                />
              </div>
            )}
            {["slot_booking", "slot_booking_total"].includes(activeTab) && (
              <div className="mt-5 mb-4">
                <SelectAgent
                  name="Select Techno Agent"
                  selectedAgent={selectMaladAgent}
                  setSelectedAgent={setMaladSelectAgent}
                  agent={agent}
                  lead={true}
                  level={2}
                />
              </div>
            )}

            {activeTab == "ivr_booking" && (
              <div className="mt-5 mb-4">
                <SelectAgent
                  name="Select Ivr Agent"
                  selectedAgent={selectIvr}
                  setSelectedAgent={setIvrAgent}
                  agent={agent}
                  lead={false}
                  level={4}
                  ivr={true}
                />
              </div>
            )}
            <div className="mt-5">
              <Select
                allowClear
                placeholder="Status"
                className="w-100"
                onChange={(role) => {
                  setSelectedStatus(role);
                }}
                options={activeStatus}
              />
            </div>
            <div className="mt-5">
              <Select
                allowClear
                placeholder="Attempt"
                className="w-100"
                onChange={(role) => {
                  setSelectAttempt(role);
                }}
                options={attemptStatus}
              />
            </div>
            {activeTab == "slot_booking" && (
              <div className="mt-5">
                <Select
                  allowClear
                  placeholder="Select Slot Type"
                  className="w-100"
                  onChange={(slot) => {
                    setSlotType(slot);
                  }}
                  options={slotLead}
                  value={slotType}
                />
              </div>
            )}
            {/* Commented because need to implement */}
            {/* <div className="mt-4">
              <Select
                allowClear
                placeholder="Filter by Gender"
                onChange={(selectedGender) => setSelectedGender(selectedGender)}
                className="w-100"
              >
                <Option value="M">Male</Option>
                <Option value="F">Female</Option>
              </Select>
            </div>
            <div className="mt-4">
              <Select
                allowClear
                options={orderOptions}
                placeholder="Filter Order"
                onChange={(selectedRowKeys) => {
                  setOrderFilter(selectedRowKeys);
                }}
                className="w-100"
              />
            </div> */}
            <div className="d-flex justify-content-between gap-3 mt-5">
              <Button
                variant="primary"
                className="mt-4 flex-1"
                onClick={() => {
                  applyFilter();
                  handleClose();
                }}
              >
                Apply Filter
              </Button>
              <Button
                variant="primary"
                className="mt-4 flex-1"
                onClick={clearFilter}
              >
                Clear Filter
              </Button>
            </div>
          </div>
        </Offcanvas.Body>
      </Offcanvas>
    </>
  );
}

export default EngagementFilter;
